module.exports = __webpack_public_path__ + "static/media/folder.8d27ca18.png";